import { useEffect, useState, useRef } from "react";
import { Link, Redirect } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import FormikControl from "../../../layouts/Input/FormikControl";
import {
  Modal,
  Col,
  Row,
  Overlay,
  Button,
  Popover,
  Container,
} from "react-bootstrap";
import { connect } from "react-redux";
import { getVizShops } from "./VizShopsRequestListingAction";
import { getDropdownList } from "../../Shared/dropdownListActions";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import { Formik, Form } from "formik";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { toast } from "react-toastify";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import storage from "../../../apis/Storage";
import { isPermittedPage } from "../../../apis/Utility";
import history from "../../../history";
import { confirmAlert } from "react-confirm-alert";

const VizShopsRequestListing = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const [showDistributorViewModal, setShowDistributorViewModal] =
    useState(false);
  const [distributorCompleteData, setDistributorCompleteData] = useState(null);
  const [vizShopsRequestList, setVizShopsRequestList] = useState([]);
  const [filterValuesModal, setFilterValuesModal] = useState({
    distShopCode: "",
    shopCode: "",
    shopName: "",
  });
  const [distShopCode, setDistShopCode] = useState(null);
  const [shopCode, setShopCode] = useState(null);
  const [shopName, setShopName] = useState(null);

  //Pagination
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);

  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [showAgent, setShowAgent] = useState(false);
  const [targetAgent, setTargetAgent] = useState(null);
  const refAgent = useRef(null);
  const [showAgentViewModal, setShowAgentViewModal] = useState(false);
  const [agentsList, setAgentsList] = useState([]);
  const [searchTextAgent, setSearchTextAgent] = useState("");
  const [selectedShopId, setSelectedShopId] = useState(null);

  const getData = (page) => {
    setCurrentPageNo(page);
    let requestData = {
      pageSize: currentPageSize,
      pageNo: page,
      searchText: searchText,
    };
    if (userRights != null && userRights?.userType == "DistributorUser") {
      requestData = {
        ...requestData,
        assignedDistCenters: userRights?.distCenterIds,
      };
    }
    props.getVizShopsData(requestData);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    let requestData = {
      pageSize: pageSize,
      pageNo: 0,
      searchText: searchText,
    };
    if (userRights != null && userRights?.userType == "DistributorUser") {
      requestData = {
        ...requestData,
        assignedDistCenters: userRights?.distCenterIds,
      };
    }
    props.getVizShopsData(requestData);
  };

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setSearchText(text);
  };

  useEffect(() => {
    let requestData = {
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    };
    if (userRights != null && userRights?.userType == "DistributorUser") {
      requestData = {
        ...requestData,
        assignedDistCenters: userRights?.distCenterIds,
      };
    }
    props.getVizShopsData(requestData);
  }, [searchText]);
  useEffect(() => {
    if (props.VizShopsRequestListing) {
      setVizShopsRequestList(props.VizShopsRequestListing);
      if (props.VizShopsRequestListing.length > 0) {
        setTotalRecords(props.VizShopsRequestListing[0].totalRecords);
      } else {
        setTotalRecords(0);
      }
    }
  }, [props.VizShopsRequestListing]);
  const LoadDataByfilter = (event) => {
    if (!event) {
      return;
    }

    props.getVizShopsData({
      DistShopCode: distShopCode,
      ShopCode: shopCode,
      ShopName: shopName,
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    });
    setShow(false);
  };

  const handleResetFilters = (resetForm) => {
    setShopName("");
    setShopCode("");
    setDistShopCode("");
    resetForm();
    setFilterValuesModal({
      distShopCode: "",
      shopCode: "",
      shopName: "",
    });
  };

  const OpenFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const NavigateToEditShop = (id, readOnly) => {
    let request = true;
    history.push(`/EditShop/${id}/${request}/${readOnly}`);
    history.go(`/EditShop/${id}/${request}/${readOnly}`);
  };

  var columns = [
    {
      Header: "Viz ID",
      accessor: "vizShopCode",
    },
    {
      Header: "Shop Name",
      accessor: "vizShopName",
      filter: "includes", // new
    },
    {
      Header: "CNIC",
      accessor: "cnic",
    },
    {
      Header: "Contact No's",
      accessor: "contactNo",
    },
    {
      Header: "Shop Category",
      accessor: "shopCategory",
    },
    {
      Header: "Address",
      accessor: "address",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Action",
      id: "edit",
      accessor: "id",
      Cell: (row) => (
        <div style={{ width: "106px" }}>
          {isPermittedPage("edit", props.actions, props.userRole) && (
            <button
              onClick={() => Edit(row.value)}
              className="btn btn-sm"
              hidden={
                row.row.original.status == "Approved" ||
                row.row.original.status == "Rejected"
              }
            >
              <i className="fas fa-edit"></i>
            </button>
          )}
          &nbsp;
          {isPermittedPage("view details", props.actions, props.userRole) && (
            <button onClick={() => View(row.value)} className=" btn btn-sm">
              <i className="fas fa-eye"></i>
            </button>
          )}
        </div>
      ),
    },
  ];

  const View = (id) => {
    NavigateToEditShop(id, true);
  };

  const Edit = (id) => {
    NavigateToEditShop(id, false);
  };

  return (
    <div>
      {isPermittedPage("View", props.actions, props.userRole) && (
        <>
          <VzPageContainer title="VizLink Shops > Manage Shops List">
            <Row>
              <Col md={{ span: 3 }} style={{ float: "left" }}>
                <h4>
                  <b>Manage Shops Listing</b>
                </h4>
              </Col>
              <Col md={{ span: 3, offset: 6 }} style={{ float: "right" }}></Col>
            </Row>
            <Row>
              <Col md={12} style={{ float: "right" }}>
                <Row>
                  <Col md={3} style={{ float: "right" }}>
                    <div ref={ref}>
                      <Button
                        onClick={OpenFilterModal}
                        className="m-3"
                        variant="outline-primary"
                      >
                        <i className="fa fa-filter" />
                        Filters
                      </Button>

                      <Overlay
                        show={show}
                        target={target}
                        placement="bottom"
                        container={ref}
                        containerPadding={20}
                        width="430px"
                        style={{ width: "430px" }}
                      >
                        <Popover id="popover-contained" width="400">
                          <Popover.Header as="h3">Filters</Popover.Header>
                          <Popover.Body>
                            <Formik
                              enableReinitialize
                              initialValues={filterValuesModal}
                              validator={() => ({})}
                              onSubmit={LoadDataByfilter}
                            >
                              {(formik) => (
                                <Form autoComplete="off">
                                  <Row>
                                    <Col xs={12} md={12}>
                                      <FormikControl
                                        formik={formik}
                                        control="input"
                                        type="DistShopCode"
                                        label="Dist. Shop Code"
                                        name="DistShopCode"
                                        handleOnChange={(value) => {
                                          setDistShopCode(value);
                                          filterValuesModal.distShopCode =
                                            value;
                                        }}
                                        value={distShopCode}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs={12} md={12}>
                                      <FormikControl
                                        formik={formik}
                                        control="input"
                                        type="ShopCode"
                                        label="Viz. Shop Code"
                                        name="ShopCode"
                                        handleOnChange={(value) => {
                                          setShopCode(value);
                                          filterValuesModal.shopCode = value;
                                        }}
                                        value={shopCode}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs={12} md={12}>
                                      <FormikControl
                                        formik={formik}
                                        control="input"
                                        type="ShopName"
                                        label="Shop Name"
                                        name="ShopName"
                                        handleOnChange={(value) => {
                                          setShopName(value);
                                          filterValuesModal.shopName = value;
                                        }}
                                        value={shopName}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs={12} md={12}>
                                      <div
                                        className="form-group"
                                        style={{ margin: "1rem 0rem" }}
                                      >
                                        <Link
                                          onClick={handleResetFilters.bind(
                                            null,
                                            formik.resetForm
                                          )}
                                          to="#"
                                          className="active"
                                          style={{
                                            padding: "0px",
                                            marginTop: "10px",
                                            float: "left",
                                          }}
                                        >
                                          Reset
                                        </Link>
                                        <Link
                                          onClick={() => {
                                            setShow(false);
                                            setTarget(null);
                                            // LoadDataByfilter({})
                                          }}
                                          to="#"
                                          className="active"
                                          style={{
                                            padding: "0px",
                                            marginTop: "10px",
                                            float: "right",
                                          }}
                                        >
                                          Cancel
                                        </Link>
                                        <div className="float-right">
                                          <Button
                                            type="submit"
                                            className="btn btn-primary"
                                            style={{
                                              marginRight: "10px",
                                              float: "right",
                                            }}
                                          >
                                            Search
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Form>
                              )}
                            </Formik>
                          </Popover.Body>
                        </Popover>
                      </Overlay>
                    </div>
                  </Col>
                </Row>

                <ServerSideDataTable
                  data={vizShopsRequestList ? vizShopsRequestList : []}
                  columns={columns ? columns : []}
                  getTrProps={(event, data) => null}
                  goToPreviousPage={(val) => getData(val)}
                  goToNextPage={(val) => getData(val)}
                  totalRecords={totalRecords}
                  pageSizeChange={(size) => pageSizeChanged(size)}
                  myPageSize={currentPageSize}
                  myIndex={currentIndex}
                  pageNo={currentPageNo}
                  searchChanged={searchChanged}
                />
              </Col>
            </Row>
          </VzPageContainer>
        </>
      )}
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    showLoadingBar: () => {
      dispatch(showLoading());
    },
    hideLoadingBar: () => {
      dispatch(hideLoading());
    },
    getDropdownListData: () => {
      dispatch(getDropdownList());
    },
    getVizShopsData: (requestData) => {
      dispatch(getVizShops(requestData));
    },
  };
};
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    VizShopsRequestListing: state.VizShopsRequestListing
      ? state.VizShopsRequestListing
      : [],
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VizShopsRequestListing);
